export const alignFirstCellLeft = (idx: number) =>
  idx === 0 ? 'left' : 'right';
